import React from 'react';
import pt from 'prop-types';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {Container, TitleContainer, PageTitle, PageSubTitle, SectionsContainer, Section, SectionTitle, QuestionBlock, Question, Answer} from './FAQ.styles';
import {useLoading, useNotFound} from '../../utils/loadingUtils';
import Error404 from '../error/Error404';
import LoadIndicator from '../../components/common/loading/LoadIndicator';

const FAQContainer = ({pageData}) => {
    const isLoading = useLoading(pageData);
    const notFound = useNotFound(pageData);

    if (isLoading) {
        return <LoadIndicator fill />;
    }

    if (notFound) {
        return <Error404 />;
    }

    const {faq, title, subtitle} = pageData;
    const {faqSectionList = []} = faq || {};

    return (
        <Container>
            {getHelmetForMetaTags(pageData)}
            <TitleContainer>
                {title && <PageTitle>{title}</PageTitle>}
                {subtitle && <PageSubTitle>{subtitle}</PageSubTitle>}
            </TitleContainer>
            <SectionsContainer>
                {faqSectionList.map(({title, questions}, i) => (
                    <Section key={i}>
                        <SectionTitle>{title || ''}</SectionTitle>
                        {questions &&
                            questions.map(({question, answer}, j) => (
                                <QuestionBlock key={j}>
                                    <Question>{question}</Question>
                                    <Answer dangerouslySetInnerHTML={{__html: answer}} />
                                </QuestionBlock>
                            ))}
                    </Section>
                ))}
            </SectionsContainer>
        </Container>
    );
};

FAQContainer.propTypes = {
    pageData: pt.object,
    getMessage: pt.func
};

export default FAQContainer;
